import React from "react";

export const EmailValidation = (name, value) => {
  let emailAddressError = "";
  value = value.toLowerCase();
  if (!value) {
    emailAddressError = "This field is required";
    return emailAddressError;
  }
  var Email1 = value.match(
    /^([a-zA-Z\d\.-]+)@([a-zA-Z\.-]+)\.([a-zA-Z]{2,8})([a-zA-Z]{2,8})?$/
  );

  // new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(
  //     value
  // );

  if (!Email1) {
    emailAddressError = "Please enter a valid email address";
    return emailAddressError;
  }
  // if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
  //     emailAddressError = "Please enter a valid email address";
  //     return emailAddressError
  // }
//   if (value.replace(/\s+/g, "").length == 0) {
//     emailAddressError = "Please enter a valid email address";
//     return emailAddressError;
//   }
  return emailAddressError;
};


// utils/validation/emailValidation.js (or wherever you keep utils)
export const emailWithSpaceValidation = (value) => {
  // Normalize input safely
  const raw = value == null ? "" : String(value);

  // Empty check (trimmed)
  if (raw.trim().length === 0) {
    return "This field is required";
  }

  // Strict: no whitespace anywhere (space, tab, newline)
  if (/\s/.test(raw)) {
    return "This field must not contain spaces";
  }

  // Lowercase for validation (keeps behavior consistent)
  const v = raw.toLowerCase();

  // Practical max length for email addresses
  if (v.length > 100) {
    return "This field must be at most 100 characters";
  }

  // Reject obvious invalid pattern like consecutive dots
  if (v.includes("..")) {
    return "Please enter a valid email address";
  }

  // Basic regex (keeps your original shape)
  const emailRe = /^([a-zA-Z\d\.-]+)@([a-zA-Z\.-]+)\.([a-zA-Z]{2,8})([a-zA-Z]{2,8})?$/;

  if (!emailRe.test(v)) {
    return "Please enter a valid email address";
  }

  // All checks passed
  return "";
};

